import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { NavService } from 'src/app/services/nav.service';

@Component({
  selector: 'app-top',
  templateUrl: './top.component.html',
  styleUrls: ['./top.component.scss']
})
export class TopComponent implements OnInit, OnDestroy {
  constructor(
    public auth: AuthService,
    private nav: NavService,
  ) {}

  ngOnInit() {
    // フッターのみ非表示に設定
    setTimeout(() => {
      this.nav.hideFooter();
    });
  }

  ngOnDestroy() {
    this.nav.show();
  }
}
